(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-el-sticky]').forEach(bar => {
      if (bar.dataset.ready) return;
      const info = bar.closest('product-info');
      const form = info?.querySelector('product-form form');
      const source = form?.querySelector('[name="add"]');
      const button = bar.querySelector('[data-el-sticky-button]');
      const priceTarget = bar.querySelector('[data-el-sticky-price]');
      if (!source || !button) return;
      bar.dataset.ready = 'true';
      const sync = () => {
        button.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
        const label = source.querySelector('span')?.textContent.trim() || source.textContent.trim();
        if (button.textContent !== label) button.textContent = label;
        const price = info.querySelector('.price--on-sale .price-item--sale') || info.querySelector('.price__regular .price-item--regular');
        if (price && priceTarget && priceTarget.textContent !== price.textContent.trim()) priceTarget.textContent = price.textContent.trim();
      };
      button.addEventListener('click', () => { sync(); if (!button.disabled) { if(form.reportValidity()) source.click(); else form.scrollIntoView({block:'center',behavior:'smooth'}); } });
      const observer = new MutationObserver(sync);
      observer.observe(form, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
      const priceBox=info.querySelector('[id^="price-"]');
      if(priceBox) observer.observe(priceBox,{childList:true,subtree:true});
      const io = new IntersectionObserver(([entry]) => { bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; sync(); },{threshold:0});
      io.observe(source);
      info.addEventListener('change',sync);
      info.addEventListener('eliane:cleanup',()=>{observer.disconnect();io.disconnect();info.removeEventListener('change',sync);},{once:true});
      sync();
    });
  }
  setup();
  document.addEventListener('shopify:section:load',e=>setup(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('product-info').forEach(info=>info.dispatchEvent(new Event('eliane:cleanup'))));
})();
